enum salesRepresentativeRoutes {
  NEW_PREORDER = "newPreOrder",
  LIST_CLIENTS = "clients",
  INFOS_CLIENTS_REPRESENTANT = "infosClientRepresentant",
  LIST_PRE_COMMANDES = "listPreCommandes",
  LIST_COMMANDES = "listCommandes",
    CHANGE_PASSWORD = "changePass"
}

export default salesRepresentativeRoutes;
